import { z } from 'zod';

/**
 * 统一响应包络 — backend_app 全量遵循 {code, message, data}。
 */
export const apiResponseSchema = <T extends z.ZodTypeAny>(data: T) =>
  z.object({
    code: z.number(),
    message: z.string(),
    data: data.optional(),
  });

export type ApiResponse<T> = {
  code: number;
  message: string;
  data?: T;
};

/** 分页响应。 */
export const paginationSchema = <T extends z.ZodTypeAny>(item: T) =>
  z.object({
    items: z.array(item),
    total: z.number().int().nonnegative(),
    page: z.number().int().positive(),
    page_size: z.number().int().nonnegative(),
    stats: z.record(z.unknown()).optional(),
  });

export type Pagination<T> = {
  items: T[];
  total: number;
  page: number;
  page_size: number;
  stats?: Record<string, unknown>;
};
